import { render } from "./TaskButton.vue?vue&type=template&id=e87d5158&scoped=true"
import script from "./TaskButton.vue?vue&type=script&lang=js"
export * from "./TaskButton.vue?vue&type=script&lang=js"

import "./TaskButton.vue?vue&type=style&index=0&id=e87d5158&lang=scss&scoped=true"

import exportComponent from "../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87d5158"]])

export default __exports__